import {
  DP02,
  Pagination,
  formatDate,
  formatEpochDate,
  formatTrade,
  getIsCrypto,
  toNumberOrNull,
} from "../../helpers/helperFunctions";
import ViewModal from "./components/StrategyViewModal";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import AddOns from "@/components/AddOnsForm";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useToast } from "@/components/ui/use-toast";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { cn } from "@/lib/utils";
import { GlobeIcon } from "@radix-ui/react-icons";
import { Eye, Info, Loader2 } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FaBell, FaCube } from "react-icons/fa";
import { IoClose, IoExtensionPuzzleSharp } from "react-icons/io5";
import UndeployModal from "@/components/common/UndeployModal";
import { AccentColor, SharpRatioString } from "@/helpers/types";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import AlertStrategyModal from "../../components/AlertStrategyModal";
import Loader from "../../components/Loader";
import ChartComponent from "./components/ChartComponent";
import MonthlyStrategyPerformance from "./components/MonthlyStrategyPerformance";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { useUserContext } from "@/contexts/userContext";
import {
  useGetLiveDeploymentStats,
  useGetLogos,
  useGetMonitorDeploymentStats,
  useGetStrategiesByUser,
  useGetStrategyPerformanceStats,
  usePostDeleteMultipleStrategies,
  usePostPublishStrategies,
  usePostUndeployLiveStrategy,
  usePostUnDeployNotificationDeployment,
} from "@/api/strategyApi";
import { useQueryClient } from "@tanstack/react-query";
import Slider from "react-slick";

const Section2 = () => {
  const { user } = useUserContext();
  const [undeployItem, setUndeployItem] = useState<null | any>(null);
  const router = useRouter();
  const { toast } = useToast();
  const { darkTheme } = useDarkTheme();
  const { t } = useTranslation("test");
  const strategiesPerPage = useMemo(() => 6, []);
  const [loading, setLoading] = useState(false);
  const [tilesData, setTilesData] = useState<any>({});
  const [createdListDataItems, setCreatedListDataItems] = useState<any>([]);
  const [selectedStrategies, setSelectedStrategies] = useState<any>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const [cubeLoading, setCubeLoading] = useState<any>({
    id: "",
    status: false,
  });
  const [selectedStrategy, setSelectedStrategy] = useState<any>({});

  const [logos, setLogos] = useState<any>(new Map());
  const [alertModal, setAlertModal] = useState<any>({
    display: false,
    strategyId: "",
  });
  const [currentCreatedPage, setCurrentCreatedPage] = useState(1);
  const [createdTotalCount, setCreatedTotalCount] = useState(0);
  const [modal, setModal] = useState(false);
  const [monthlyData, setMonthlyData] = useState([]);
  const queryClient = useQueryClient();

  const {
    data: monitorDeploymentData,
    isLoading: monitorDeploymentLoading,
    isSuccess: monitorDeploymentSuccess,
  } = useGetMonitorDeploymentStats(user?.user_id);

  const {
    mutateAsync: getLogo,
    data: logoData,
    isPending: logoPending,
    isSuccess: logoSuccess,
  } = useGetLogos();

  const {
    data: userStrategyData,
    isLoading: isUserStrategyLoading,
    isSuccess: isUserStrategySuccess,
    refetch: refreshUserStrategies,
  } = useGetStrategiesByUser({
    user_id: user?.user_id,
    page: currentCreatedPage.toString(),
  });

  const {
    data: userStrategyPerformanceData,
    isLoading: isUserStrategyPerformanceLoading,
    isSuccess: isUserStrategyPerformanceSuccess,
  } = useGetStrategyPerformanceStats(user?.user_id);

  const { mutateAsync: undeployNotificationDeployment } =
    usePostUnDeployNotificationDeployment();
  const { mutateAsync: undeployLiveStrategy } = usePostUndeployLiveStrategy();
  const { mutateAsync: deleteStrategy } = usePostDeleteMultipleStrategies();
  const { mutateAsync: publishStrategy } = usePostPublishStrategies();
  const {
    data: liveDeploymentData,
    isLoading: liveDataLoading,
    isSuccess: liveDataSuccess,
  } = useGetLiveDeploymentStats(user?.user_id);

  const settings = {
    className: "variable-width",
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 500,
    initialSlide: 0,
    infinite: false,
  };

  const scrollRef = useRef<any>(null);

  const delete_strategies = async (
    user: any,
    strategy_ids: string,
    is_only_item: Boolean
  ) => {
    try {
      await deleteStrategy({
        user_id: user?.user_id,
        strategy_ids: strategy_ids,
      });
      if (is_only_item) {
        addCreatedListBadges(
          createdListDataItems.filter(
            (item: any) => item.strategy.id != strategy_ids
          )
        );
      } else {
        addCreatedListBadges(
          createdListDataItems.filter(
            (item: any) => !selectedStrategies.includes(item.strategy.id)
          )
        );
      }
      queryClient.invalidateQueries({
        queryKey: ["get_strategies_by_user", user?.user_id, currentCreatedPage],
      });
      await refreshUserStrategies();
      toast({
        title: "Strategy has been removed successfully.",
      });
    } catch (error) {
      toast({
        title: error?.response?.data?.detail,
        variant: "destructive",
      });
    }
  };

  useEffect(() => {
    if (router?.query?.flag) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
      let { flag, ...query } = router.query;
      router.replace({ query }, void 0, { shallow: true });
    }
  }, [router]);

  const handleSelected = (val: string) => {
    if (selectedStrategies.includes(val)) {
      setSelectedStrategies(
        selectedStrategies.filter((item: any) => item != val)
      );
    } else {
      setSelectedStrategies([...selectedStrategies, val]);
    }
  };

  const createBadgesFromData = (item: any) => {
    return (
      Object.keys(item?.badges || {}).map((badge: string, index: number) => {
        let color = "";

        switch (badge.toLowerCase()) {
          case "indicators" || "indicator":
            color = "border-indicators text-indicators hover:text-indicators ";
            break;
          case "datas" || "data":
            color = "border-data text-data hover:text-data ";
            break;
          case "patterns":
            color = "border-white text-white hover:text-white ";
            break;
          case "logics":
            color =
              "border-tradingLogic text-tradingLogic hover:text-tradingLogic ";
            break;
          case "actions":
            color = "border-action text-action hover:text-action ";
            break;
          default:
            color = "border-green";
        }
        return item?.badges?.[badge].map((badgeName: string, i: number) => (
          <div className="mr-2" key={index + "-" + i}>
            <Badge variant="outline">{badgeName}</Badge>
          </div>
        ));
      }) || []
    );
  };

  const onPageChange = (val: number) => {
    setCurrentCreatedPage(val);
    changeCreatedPage(val);
  };

  const publishUnpublishStrategy = async (
    vs_id: number,
    is_published: number,
    item: any
  ) => {
    const publish_state = is_published == 1 ? "0" : "1";
    try {
      await publishStrategy({
        user_id: user?.user_id,
        strategy_id: vs_id.toString(),
        publish_state: publish_state,
      });

      if (publish_state == "0") {
        toast({
          title: "Strategy successfully unpublished from your public profile",
        });
      } else {
        toast({
          title: "Strategy published successfully to your public profile",
        });
      }
      queryClient.invalidateQueries({
        queryKey: ["get_strategies_by_user", user?.user_id, currentCreatedPage],
      });
      await refreshUserStrategies();
    } catch (error) {
      toast({
        title: error?.response.data.detail,
        variant: "destructive",
      });
    }
  };

  const handleUnDeploy = async (
    vs_id: number,
    deployVirtual: boolean,
    alertStrategy: string,
    dep_id: number
  ) => {
    setCubeLoading({
      id: vs_id,
      status: true,
    });
    if (alertStrategy == "1") {
      if (deployVirtual) {
        await undeployNotificationDeployment({
          user_id: user?.user_id,
          deployment_id: dep_id.toString(),
        });
      }
    } else {
      if (deployVirtual && user?.user_id) {
        await undeployLiveStrategy({
          userId: user?.user_id,
          strategy_id: vs_id.toString(),
        });
      }
    }
    queryClient.invalidateQueries({
      queryKey: ["get_strategies_by_user", user?.user_id, currentCreatedPage],
    });
    await refreshUserStrategies();
    setCubeLoading({
      id: vs_id,
      status: false,
    });
  };

  const [headerTrades, setHeaderTrades] = useState({
    total_live_strategies: 0,
    total_live_deployments: 0,
    total_virtual_deployments: 0,
    scanners_deployed: 0,
    total_trades: 0,
  });

  const getLogos = async (data: any) => {
    const uniqueSymbols = Array.from(
      new Set(data?.data?.items?.map?.((item: any) => item.strategy.symbol))
    );

    await getLogo({ symbols: uniqueSymbols });
  };

  const changeCreatedPage = (val: number = currentCreatedPage) => {
    setCurrentCreatedPage(val);
  };

  const addCreatedListBadges = (createdListDataItems: any[]) => {
    if (createdListDataItems.length > 0) {
      setLoading(true);
      const updatedList = createdListDataItems.map((item) => ({
        ...item,
        badges: item.block_data,
      }));
      setCreatedListDataItems(updatedList);
      setLoading(false);
    } else {
      setCreatedListDataItems([]);
    }
  };

  const alertStrategy = (strategy_id: any, symbol: string) => {
    setAlertModal({ display: true, strategyId: strategy_id });
  };

  const removeItem = (itemID?: string) => {
    if (itemID == "" || itemID == undefined) {
      if (selectedStrategies.length == 0) {
        return false;
      }
    } else {
    }
  };

  const handleError = (val: any) => {
    toast({
      title: val,
      variant: "destructive",
    });
  };
  const handleCustomMessage = (val: any) => {
    if (val.status == 200) {
      toast({
        title: val.data.message,
        variant: "default",
      });
    } else {
      toast({
        title: val.data.message,
        variant: "destructive",
      });
    }
  };
  const handleFormState = (val: number, data?: any) => {
    if (data?.broker) {
      // setBroker(data.broker);
    }
  };

  useEffect(() => {
    if (monitorDeploymentSuccess && monitorDeploymentData) {
      const d = monitorDeploymentData?.data?.last_30_trades.sort(
        (a: any, b: any) =>
          parseFloat(a.trade_closed_at) - parseFloat(b.trade_closed_at)
      );
      setMonthlyData(d);
    }
  }, [monitorDeploymentSuccess, monitorDeploymentLoading]);

  useEffect(() => {
    if (logoSuccess && logoData) {
      var logos_map = new Map();
      for (var item in logoData.data.data) {
        logos_map.set(item, logoData.data.data[item]);
      }
      setLogos(logos_map);
    }
  }, [logoPending, logoSuccess]);

  useEffect(() => {
    if (isUserStrategySuccess && userStrategyData) {
      addCreatedListBadges(userStrategyData.data.items);
      setCreatedTotalCount(userStrategyData.data.total);
      getLogos(userStrategyData);
    }
  }, [isUserStrategyLoading, userStrategyData, isUserStrategySuccess]);
  useEffect(() => {
    if (isUserStrategyPerformanceSuccess && userStrategyPerformanceData) {
      setTilesData(userStrategyPerformanceData?.data);
    }
  }, [
    isUserStrategyPerformanceLoading,
    userStrategyPerformanceData,
    isUserStrategyPerformanceSuccess,
  ]);

  useEffect(() => {
    if (liveDataSuccess && liveDeploymentData?.data) {
      const result = {
        ...liveDeploymentData?.data,
        total_strategies: liveDeploymentData.data.total_strategies || 0,
        total_live_deployments:
          liveDeploymentData.data.total_live_deployments || 0,
        total_live_strategies:
          liveDeploymentData.data.total_live_strategies || 0,
        total_trades: liveDeploymentData.data.total_trades || 0,
        total_volume: liveDeploymentData.data.total_volume || 0,
        broker_win_p: liveDeploymentData.data.broker_win_p || 0,
        net_cumulative_profit:
          liveDeploymentData.data.net_cumulative_profit || 0,
        total_exposure: liveDeploymentData.data.total_exposure || 0,
        netPosition_broker:
          liveDeploymentData.data.broker_loss != null &&
          liveDeploymentData.data.broker_profit != null
            ? liveDeploymentData.data.broker_profit +
              liveDeploymentData.data.broker_loss
            : 0,
      };

      setHeaderTrades(result);
    }
  }, [liveDataSuccess, liveDataLoading, liveDeploymentData]);
  return (
    <div className="flex lg:flex-row lg:flex-nowrap flex-wrap mb-5 lg:mb-0 gap-5 my-5">
      <ViewModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        selected={selected}
        token={user?.token}
        showValues={true}
      />

      <div className="flex flex-col w-full h-full gap-5">
        <Dialog open={modal} onOpenChange={(open: any) => setModal(open)}>
          <DialogContent className="max-w-5xl ">
            <DialogHeader>
              <DialogTitle className="flex gap-1 items-center text-[--marketplace-blue]">
                {t("strategyAddOns")} <IoExtensionPuzzleSharp />
              </DialogTitle>
              <DialogDescription>{t("tradeConveniently")}</DialogDescription>
            </DialogHeader>
            <AddOns
              live={true}
              strategyId={selectedStrategy?.strategyId}
              error={handleError}
              success={handleCustomMessage}
              formState={3}
              submit={handleFormState}
              deployVirtually={() => null}
              deployType={"live"}
              setModal={setModal}
              isCrypto={selectedStrategy?.isCrypto}
            />
          </DialogContent>
        </Dialog>

        <Card className="w-full flex flex-col lg:flex-row ">
          <div className={"mb-5 lg:mb-0 w-full grow"}>
            <div className="flex rounded-lg">
              <div className="w-full relative grow rounded-lg">
                {loading && (
                  <div className="">
                    <Loader2 className="h-5 w-5 animate-spin" />
                  </div>
                )}
                <>
                  <CardHeader>
                    <CardTitle>
                      <div className="flex gap-1 items-center text-2xl font-bold tracking-tight">
                        {t("testStrategyPerformance")}
                      </div>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex flex-col  grow justify-between ">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full justify-between ">
                      {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-8 gap-y-4 w-full justify-items-center"> */}
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                        <Card className="shadow-none border-0 h-fit">
                          <div className=" flex flex-col  items-start font-bold">
                            <span className="text-muted-foreground h-[40px]">
                              {t("Total Backtests")}
                            </span>
                            <span className=" text-2xl mt-2">
                              <div className="text-2xl font-bold">{`${
                                tilesData?.total_backtests > 0 ? "" : ""
                              }${
                                formatTrade(tilesData?.total_backtests) || 0
                              } `}</div>
                            </span>
                          </div>
                        </Card>
                        <Card className="shadow-none border-0 h-fit">
                          <div className=" flex flex-col cursor-pointer items-start font-bold">
                            <span className="text-muted-foreground h-[40px]">
                              {t("Total Strategies Published")}
                            </span>
                            <span className="flex text-2xl items-center">
                              <div
                                className={`text-2xl font-bold ${
                                  tilesData?.total_published > 0
                                    ? "text-[--marketplace-green]"
                                    : "text-[--marketplace-red]"
                                }`}
                              >{`${tilesData?.total_published > 0 ? "" : ""}${
                                formatTrade(tilesData?.total_published) || 0
                              } `}</div>
                              <div className="hover:bg-transparent ml-2">
                                <FaArrowUpRightFromSquare
                                  size={"12px"}
                                  className="text-[#2252CC]"
                                />
                              </div>
                            </span>
                          </div>
                        </Card>
                        <Card className="shadow-none border-0 h-fit">
                          <div
                            className=" flex flex-col cursor-pointer items-start font-bold"
                            onClick={() => router.push("/deploy")}
                          >
                            <span className="text-muted-foreground h-[40px]">
                              {t("Deployments")}
                            </span>
                            <span className="flex text-2xl items-center">
                              <div
                                className={`text-2xl font-bold  ${
                                  headerTrades?.total_live_deployments +
                                    headerTrades?.total_virtual_deployments +
                                    headerTrades?.scanners_deployed >
                                  0
                                    ? "text-[--marketplace-green]"
                                    : "text-[--marketplace-red]"
                                }`}
                              >
                                {headerTrades
                                  ? formatTrade(
                                      toNumberOrNull(
                                        headerTrades?.total_live_deployments +
                                          headerTrades?.total_virtual_deployments +
                                          headerTrades?.scanners_deployed,
                                        0
                                      )
                                    )
                                  : "0"}
                              </div>
                              <div className="hover:bg-transparent ml-2">
                                <FaArrowUpRightFromSquare
                                  size={"12px"}
                                  className="text-[#2252CC]"
                                />
                              </div>
                            </span>
                          </div>
                        </Card>

                        <Card className="shadow-none border-0 h-fit">
                          <div className=" flex flex-col gap-2 items-start font-bold">
                            <span className="text-muted-foreground h-[40px] md:w-[150px]">
                              {t("Total Strategies Created")}
                            </span>
                            <span className="text-2xl">
                              <div className="text-2xl font-bold ">{`${
                                tilesData?.total_created > 0 ? "" : ""
                              }${
                                formatTrade(tilesData?.total_created) || 0
                              } `}</div>
                            </span>
                          </div>
                        </Card>

                        <Card className="shadow-none border-0 h-fit">
                          <div className=" flex flex-col gap-2 items-start font-bold">
                            <span className="text-muted-foreground h-[40px]">
                              {t("Total Copiers")}
                            </span>
                            <span className="text-2xl">
                              <div
                                className={`text-2xl font-bold ${
                                  tilesData?.total_copiers > 0
                                    ? "text-[--marketplace-green]"
                                    : "text-[--marketplace-red]"
                                }`}
                              >{`${tilesData?.total_copiers > 0 ? "" : ""}${
                                formatTrade(tilesData?.total_copiers) || 0
                              } `}</div>
                            </span>
                          </div>
                        </Card>

                        <Card className="shadow-none border-0 h-fit">
                          <div className=" flex flex-col gap-2 items-start font-bold">
                            <span className="text-muted-foreground h-[40px]">
                              {t("Trades Executed")}
                            </span>
                            <span className="text-2xl">
                              <div className="text-2xl font-bold text-[--marketplace-blue]">
                                {formatTrade(
                                  toNumberOrNull(headerTrades?.total_trades, 0)
                                )}
                              </div>
                            </span>
                          </div>
                        </Card>
                      </div>

                      <MonthlyStrategyPerformance
                        monthlyData={monthlyData}
                        t={t}
                      />
                    </div>
                    <ScrollArea className="h-fit min-h-[200px] mt-6">
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead className="whitespace-nowrap min-w-fit">
                              {t("table.head.strategyName")}
                            </TableHead>
                            <TableHead className="whitespace-nowrap min-w-[75px] w-40">
                              {t("table.head.createdAt")}
                            </TableHead>
                            <TableHead className="whitespace-nowrap w-36">
                              {t("table.head.asset")}
                            </TableHead>
                            <TableHead className="w-24">
                              <div className="flex flex-col capitalize">
                                {t("table.head.deployed")}
                              </div>
                            </TableHead>
                            <TableHead className="w-24">
                              <div className="flex flex-col">
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger>
                                      <div className="flex capitalize">
                                        <div>{t("Publish")}</div>
                                        <div className="flex align-top">
                                          <Info className="w-[10px] ml-1" />
                                        </div>
                                      </div>{" "}
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      <p>
                                        {t(
                                          "Strategies published via this will be visible on your"
                                        )}{" "}
                                        <a
                                          target="_blank"
                                          href={
                                            "/profile/" + user?.user.unique_key
                                          }
                                          className="underline"
                                        >
                                          {t("public profile")}
                                        </a>
                                        <br></br>
                                        {t(
                                          "Please note: Newly published strategies will become visible after a short delay."
                                        )}
                                      </p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              </div>
                            </TableHead>

                            <TableHead className="whitespace-wrap w-28">
                              {t("Cumulative Returns")}
                            </TableHead>

                            <TableHead className="whitespace-nowrap w-11"></TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {createdListDataItems.map(
                            (item: any, index: number) => {
                              const isDeploy =
                                item?.is_notification == "1"
                                  ? item?.is_notification_deployed
                                  : item?.is_deployed_live;

                              const data =
                                item?.backtest_data &&
                                JSON.parse(item?.backtest_data);
                              const label = data?.chart
                                ? Object.keys(data?.chart)
                                : null;
                              const values = data?.chart
                                ? Object.values(data?.chart)
                                : null;
                              const isNegativeSum =
                                //@ts-ignore
                                values?.reduce((cur, acc) => acc + cur, 0) < 0;
                              const sharpRatio =
                                typeof data?.sr === "number"
                                  ? data?.sr?.toLocaleString("en-US", DP02)
                                  : data?.sr || "NA";
                              const DD =
                                typeof data?.dd === "number"
                                  ? data?.dd?.toLocaleString("en-US", {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    })
                                  : "NA";
                              const days: any = {
                                "1": t("Mon"),
                                "2": t("Tue"),
                                "3": t("Wed"),
                                "4": t("Thu"),
                                "5": t("Fri"),
                                "6": t("Sat"),
                                "0": t("Sun"),
                              };
                              const addOns = JSON.parse(
                                item?.strategy?.add_ons
                              );
                              const [day, month, year] =
                                addOns?.strategy_expiration
                                  ? addOns?.strategy_expiration
                                      ?.split("/")
                                      .map(Number)
                                  : new Array(3).fill("NA");

                              const canvasData = item?.strategy?.canvas_data
                                ? JSON.parse(item?.strategy?.canvas_data)
                                : {};
                              const nodes = canvasData?.filter?.(
                                (item: any) => item.type === "selectorNode"
                              );

                              const edges = canvasData?.filter?.(
                                (item: any) => item.type === "buttonedge"
                              );

                              return (
                                <React.Fragment
                                  key={"createdlistItem-" + index}
                                >
                                  <UndeployModal
                                    isOpen={
                                      undeployItem?.strategy?.id ===
                                      item.strategy.id
                                    }
                                    onClose={() => setUndeployItem(null)}
                                    liveStrategyUndeploy={() => {
                                      handleUnDeploy(
                                        item.strategy.id,
                                        item?.is_notification == "1"
                                          ? item?.is_notification_deployed
                                          : item?.is_deployed_live,
                                        item?.is_notification,
                                        item?.virtual_deployment_id
                                      );
                                    }}
                                  />
                                  <TableRow>
                                    <TableCell
                                      className="whitespace-nowrap max-w-[100px] cursor-pointer"
                                      onClick={() =>
                                        item?.strategy.is_notification == "1" ||
                                        item?.strategy.is_notification == 1
                                          ? alertStrategy(
                                              item.strategy.id,
                                              item.strategy.symbol
                                            )
                                          : router.push(
                                              `/strategy_details/${
                                                item.strategy.id
                                              }?locale=${
                                                router.query.locale || "en"
                                              }`
                                            )
                                      }
                                    >
                                      <span className="flex flex-row gap-2 justify-between items-center w-full">
                                        <span className="cursor-pointer transition-all duration-500 max-w-full overflow-hidden text-ellipsis">
                                          {item.strategy.strategy_name}
                                        </span>

                                        <div className="flex w-[75px] gap-1 justify-end items-center">
                                          {item?.strategy.is_notification ==
                                            "1" && (
                                            <div
                                              title={t("notificationStrategy")}
                                              className="flex items-center overflow-hidden cursor-pointer transition-all duration-1000 hover:grayscale"
                                            >
                                              <FaBell />
                                            </div>
                                          )}

                                          <HoverCard>
                                            <HoverCardTrigger>
                                              {item?.strategy.add_ons != null &&
                                                item?.strategy.add_ons !=
                                                  "{}" &&
                                                (item?.is_deployed_virtual ||
                                                  item?.is_deployed_live) && (
                                                  <div className="flex items-center overflow-hidden cursor-pointer transition-all duration-1000 hover:grayscale ">
                                                    <IoExtensionPuzzleSharp />
                                                  </div>
                                                )}
                                            </HoverCardTrigger>
                                            <HoverCardContent className="w-[350px] p-0">
                                              <div className="font-bold px-4 text-lg my-2">
                                                {t("Strategy add-ons enabled")}
                                              </div>
                                              <Table>
                                                <TableBody>
                                                  <TableRow className="text-xs py-0">
                                                    <TableCell className="text-xs py-0.5 whitespace-normal">
                                                      {t("Day Switch")} {"(on)"}
                                                    </TableCell>
                                                    <TableCell className="text-xs flex gap-2 py-0.5">
                                                      {addOns?.day_switch
                                                        ? JSON.parse(
                                                            addOns?.day_switch
                                                          )?.map(
                                                            (
                                                              item: any,
                                                              index: number
                                                            ) => (
                                                              <Badge
                                                                key={index}
                                                                variant="outline"
                                                              >
                                                                {days?.[item]}
                                                              </Badge>
                                                            )
                                                          )
                                                        : "NA"}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow className="text-xs py-0">
                                                    <TableCell className="text-xs py-0.5 whitespace-normal">
                                                      {t("Strategy Expiration")}
                                                    </TableCell>
                                                    <TableCell className="text-xs flex gap-2 py-0.5">
                                                      {addOns?.strategy_expiration
                                                        ? formatDate(
                                                            new Date(
                                                              year,
                                                              month - 1,
                                                              day
                                                            ),
                                                            "DD-MMM-YY"
                                                          )
                                                        : "NA"}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow className="text-xs py-0">
                                                    <TableCell className="text-xs py-0.5 whitespace-normal">
                                                      {t(
                                                        "Number of trades switch"
                                                      )}
                                                    </TableCell>
                                                    <TableCell className="text-xs flex gap-2 py-0.5">
                                                      {addOns?.killSwitch
                                                        ? addOns?.killSwitch
                                                        : "NA"}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow className="text-xs py-0">
                                                    <TableCell
                                                      className="text-xs py-0.5 whitespace-normal
                                                "
                                                    >
                                                      {t(
                                                        "Profit satisfaction shutdown"
                                                      )}
                                                    </TableCell>
                                                    <TableCell className="text-xs flex gap-2 py-0.5">
                                                      {addOns?.profit
                                                        ? "$" + addOns?.profit
                                                        : "NA"}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow className="text-xs py-0">
                                                    <TableCell className="text-xs py-0.5 whitespace-normal">
                                                      {t(
                                                        "Loss realization shutdown"
                                                      )}
                                                    </TableCell>
                                                    <TableCell className="text-xs flex gap-2 py-0.5">
                                                      {addOns?.loss
                                                        ? "$" + addOns?.loss
                                                        : "NA"}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow className="text-xs py-0">
                                                    <TableCell className="text-xs py-0.5">
                                                      {t("Time Switch")}{" "}
                                                      {"(off)"}
                                                    </TableCell>
                                                    <TableCell className="text-xs py-0.5">
                                                      <div className="flex gap-4">
                                                        <span>
                                                          {t("Start Time")}
                                                        </span>
                                                        <span>
                                                          {addOns?.startTime
                                                            ? addOns?.startTime
                                                            : "NA"}
                                                        </span>
                                                      </div>
                                                      <div className="flex gap-4">
                                                        <span>
                                                          {t("End Time")}
                                                        </span>
                                                        <span>
                                                          {addOns?.endTime
                                                            ? addOns?.endTime
                                                            : "NA"}
                                                        </span>
                                                      </div>
                                                      <div className="flex gap-4">
                                                        <span>
                                                          {t("Timezone")}
                                                        </span>
                                                        <span>
                                                          {addOns?.timezone
                                                            ? addOns?.timezone
                                                            : "UTC"}
                                                        </span>
                                                      </div>
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </HoverCardContent>
                                          </HoverCard>
                                          {item?.is_deployed_live != // above commented is actual
                                            false && (
                                            <div
                                              title={t("deployedVirtually")} // this is actual
                                              className="flex overflow-hidden cursor-pointer transition-all duration-1000 hover:grayscale"
                                            >
                                              <FaCube color="var(--marketplace-blue)" />
                                            </div>
                                          )}
                                          <div
                                            title={t("View performance")}
                                            className="flex justify-center items-center"
                                          >
                                            <MdOutlineKeyboardArrowRight className=" cursor-pointer text-destructive text-2xl font-extrabold" />
                                          </div>
                                        </div>
                                      </span>
                                    </TableCell>
                                    <TableCell className="whitespace-nowrap max-w-[60px]">
                                      {formatEpochDate(
                                        item.epoch_created_at,
                                        "DD-MMM-YY"
                                      )}
                                    </TableCell>
                                    <TableCell className="whitespace-nowrap max-w-[60px]">
                                      <div className="flex flex-row space-x-2 whitespace-nowrap justify-start items-center dark:opacity-80">
                                        {logos.get(
                                          item.strategy.symbol as string
                                        ) !== undefined ? (
                                          <>
                                            <img
                                              src={logos.get(
                                                item.strategy.symbol as string
                                              )}
                                              style={{
                                                maxHeight: "30px",
                                                maxWidth: "30px",
                                              }}
                                              alt={item.strategy.symbol}
                                            />
                                            <span>{item.strategy.symbol}</span>
                                          </>
                                        ) : (
                                          <>
                                            <img
                                              src={
                                                darkTheme
                                                  ? "/images/logos/Symbol_Dark.png"
                                                  : "/images/logos/Symbol_Light-30.png"
                                              }
                                              style={{
                                                maxHeight: "30px",
                                                maxWidth: "30px",
                                              }}
                                              alt={item.strategy.symbol}
                                            />
                                            <span>{item.strategy.symbol}</span>
                                          </>
                                        )}
                                        <div className="pl-1">
                                          {item.strategy.timeframe}
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell className="flex justify-center mt-2 items-center whitespace-nowrap ">
                                      {cubeLoading?.id === item.strategy.id &&
                                      cubeLoading?.status ? (
                                        <div className="w-[20px]">
                                          <Loader />
                                        </div>
                                      ) : (
                                        <span
                                          className="align-middle cursor-pointer"
                                          title={
                                            item?.strategy.is_notification ==
                                            "1"
                                              ? item?.is_notification_deployed
                                                ? t("clickHereToUnDeploy")
                                                : t("clickHereToDeploy")
                                              : item?.is_deployed_live
                                              ? t("clickHereToUnDeploy")
                                              : t("clickHereToDeploy")
                                          }
                                        >
                                          {item?.is_deployed_live ||
                                          item?.is_deployed_virtual ? (
                                            <FaCube
                                              onClick={(e) => {
                                                setUndeployItem(item); // Set the item to undeploy
                                              }}
                                              color="var(--marketplace-blue)"
                                              className={cn(
                                                "text-sm text-marketplace-blue",
                                                item?.is_notification == "1"
                                                  ? item?.is_notification_deployed
                                                    ? ""
                                                    : "opacity-30"
                                                  : item?.is_deployed_live
                                                  ? ""
                                                  : "opacity-30"
                                              )}
                                            />
                                          ) : (
                                            <FaCube
                                              color="var(--marketplace-blue)"
                                              className={cn(
                                                "text-sm",
                                                item?.is_notification == "1"
                                                  ? item?.is_notification_deployed
                                                    ? ""
                                                    : "opacity-30"
                                                  : // : item?.is_deployed_virtual // this is actual
                                                  item?.is_deployed_live
                                                  ? ""
                                                  : "opacity-30"
                                              )}
                                              onClick={() => {
                                                setModal(true);
                                                setSelectedStrategy(
                                                  (prev: any) => ({
                                                    ...prev,
                                                    isCrypto: getIsCrypto(
                                                      item?.strategy?.symbol
                                                    ),
                                                    strategyId:
                                                      item?.strategy?.id,
                                                  })
                                                );
                                              }}
                                            />
                                          )}
                                        </span>
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      <div className="flex justify-center items-center">
                                        <div
                                          className="cursor-pointer"
                                          onClick={() => {
                                            publishUnpublishStrategy(
                                              item.strategy.id,
                                              item.is_published,
                                              item
                                            );
                                          }}
                                        >
                                          <GlobeIcon
                                            className={cn(
                                              " w-[15px]",
                                              item?.is_published == 1
                                                ? "text-[#316ACD]"
                                                : "opacity-30"
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell className="whitespace-nowrap ">
                                      {label && values ? (
                                        <ChartComponent
                                          label={label}
                                          values={values}
                                          borderColor={
                                            isNegativeSum
                                              ? "#E76E50"
                                              : AccentColor.GREEN
                                          }
                                        />
                                      ) : (
                                        "NA"
                                      )}
                                    </TableCell>

                                    <TableCell className="whitespace-nowrap">
                                      <div className="flex">
                                        <div
                                          className="mr-8 text-sm font-bold cursor-pointer text-muted-foreground hover:text-[#545454]"
                                          onClick={() => {
                                            setSelected({
                                              nodes,
                                              edges,
                                              symbol: item.strategy.symbol,
                                              timeframe:
                                                item.strategy.timeframe,
                                            });
                                            setShowModal(true);
                                          }}
                                        >
                                          <div className="flex items-center">
                                            <div>
                                              <Eye className="w-[15px]" />
                                            </div>
                                            <div className="ml-1">
                                              {t("View")}
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={
                                            item.is_deployed_virtual ||
                                            item?.is_deployed_live
                                              ? "fa fa-trash text-xl cursor-not-allowed"
                                              : "fa fa-trash text-xl cursor-pointer"
                                          }
                                          onClick={() => {
                                            item.is_deployed_virtual ||
                                            item?.is_deployed_live
                                              ? ""
                                              : handleSelected(item.vs_id);
                                            removeItem(item.strategy.id);
                                          }}
                                        >
                                          <AlertDialog>
                                            <AlertDialogTrigger asChild>
                                              {item.is_deployed_virtual ||
                                              item?.is_deployed_live ? (
                                                <HoverCard openDelay={0}>
                                                  <HoverCardTrigger className="text-red-foreground">
                                                    <IoClose />
                                                  </HoverCardTrigger>
                                                  <HoverCardContent className="text-xs">
                                                    {t(
                                                      "undeployStrategyBeforeDeleting"
                                                    )}
                                                  </HoverCardContent>
                                                </HoverCard>
                                              ) : (
                                                <IoClose className="text-red-foreground font-bold" />
                                              )}
                                            </AlertDialogTrigger>
                                            <AlertDialogContent>
                                              <AlertDialogHeader>
                                                <AlertDialogTitle>
                                                  {t(
                                                    "Are you absolutely sure?"
                                                  )}
                                                </AlertDialogTitle>
                                                <AlertDialogDescription>
                                                  {
                                                    "Are you sure you want to delete? (This action is irreversible)"
                                                  }
                                                </AlertDialogDescription>
                                              </AlertDialogHeader>
                                              <div className="flex items-center space-x-2 ">
                                                <AlertDialogAction
                                                  onClick={() => {
                                                    delete_strategies(
                                                      user,
                                                      item.strategy.id,
                                                      false
                                                    );
                                                  }}
                                                >
                                                  {t("yes")}
                                                </AlertDialogAction>
                                                <AlertDialogCancel>
                                                  {t("no")}
                                                </AlertDialogCancel>
                                              </div>
                                            </AlertDialogContent>
                                          </AlertDialog>
                                        </div>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell
                                      colSpan={2}
                                      className="max-w-[250px] test-page-slider"
                                    >
                                      <div className="px-4">
                                        <Slider {...settings}>
                                          {createBadgesFromData(item || {})}
                                        </Slider>
                                      </div>
                                    </TableCell>
                                    <TableCell
                                      colSpan={4}
                                      className="max-w-[150px]"
                                    >
                                      {item.strategy.strategy_category
                                        ?.label && (
                                        <Badge variant="secondary">
                                          {
                                            item.strategy.strategy_category
                                              .label
                                          }
                                        </Badge>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                      <ScrollBar orientation="horizontal" />
                    </ScrollArea>

                    <Pagination
                      limit={strategiesPerPage}
                      totalCount={createdTotalCount}
                      currentPage={currentCreatedPage}
                      changePage={onPageChange}
                    />
                  </CardContent>
                </>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {alertModal?.display && (
        <AlertStrategyModal
          alertModal={alertModal}
          setAlertModal={setAlertModal}
          userInfo={user}
          strategyId={alertModal.strategyId}
          getData={() => {}}
        />
      )}
    </div>
  );
};
export default Section2;
